<template>
  <div class="w-full gap-4 p-4 flex items-center border-b border-gray-200">
    <div class="w-full flex max-w-7xl mx-auto">
      <router-link :to="{ name: 'home' }" class="flex flex-1 justify-start">
        <BaseLogo />
      </router-link>

      <div class="gap-4 flex flex-1 items-center justify-end">
        <BasePopover>
          <template #toggler>
            <div class="gap-2 flex items-center cursor-pointer">
              <BaseAvatar class="cursor-pointer" :name="user?.name" />
              <span class="text-sm hidden sm:block">{{ user?.name }}</span>
            </div>
          </template>

          <template #content>
            <div
              class="mt-4 px-2 py-2 gap-2 flex flex-col bg-white rounded-lg shadow-lg"
            >
              <template v-for="(item, index) in popoverItems">
                <div
                  v-if="item.type === 'divider'"
                  :key="`divider-${index}`"
                  class="h-px bg-gray-200"
                />
                <div
                  v-else
                  :key="`item-${index}`"
                  class="gap-4 px-4 py-2 flex items-center text-xl rounded-md cursor-pointer hover:bg-capino-light"
                  @click="item.handler"
                >
                  <BaseIcon class="text-gray-500" :icon="item.icon" />
                  <span class="whitespace-nowrap">{{ item.text }}</span>
                </div>
              </template>
            </div>
          </template>
        </BasePopover>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import BaseIcon from '@/components/Base/BaseIcon.vue'
import BaseAvatar from '@/components/Base/BaseAvatar.vue'
import BaseLogo from '@/components/Base/BaseLogo.vue'
import BasePopover from '@/components/Base/BasePopover.vue'

export default {
  name: 'LandingHeader',

  components: { BaseIcon, BaseAvatar, BaseLogo, BasePopover },

  computed: {
    ...mapState('user', ['user']),

    popoverItems() {
      return [
        {
          type: 'item',
          icon: 'sign-out-alt',
          text: this.$t('landing.welcomeHeader.logout'),
          handler: this.logout
        }
      ].filter(Boolean)
    }
  },

  methods: {
    ...mapActions('auth', {
      logout: 'LOGOUT'
    })
  }
}
</script>
